import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { applyReduceMotionClass } from './lib/motion';
import { captureInstallPrompt } from './lib/install';
import { registerServiceWorker } from './lib/serviceWorker';
import './styles/tokens.css';
import './styles/base.css';
import './styles/cards.css';
import './styles/home.css';
import './styles/table.css';
import './styles/sheets.css';

applyReduceMotionClass();

const root = document.getElementById('root');
if (!root) throw new Error('Missing #root element');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

captureInstallPrompt();
registerServiceWorker();
